import Vue from "vue";
import Vuex from "vuex";
import errors from "./_errors.js";
import notes from "./_notes.js";
import loader from "./_loader.js";
// import VuexPersistence from 'vuex-persist'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    errors,
    notes,
    loader
  },
  // plugins: [new VuexPersistence().plugin]
});
